function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */ /* Inspired by https://github.com/AlmeroSteyn/react-aria-live */
var $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY = 7000;
var $319e236875307eab$var$liveAnnouncer = null;
function $319e236875307eab$export$a9b970dcc4ae71a9(message) {
  var assertiveness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "assertive";
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY;
  if (!$319e236875307eab$var$liveAnnouncer) $319e236875307eab$var$liveAnnouncer = new $319e236875307eab$var$LiveAnnouncer();
  $319e236875307eab$var$liveAnnouncer.announce(message, assertiveness, timeout);
}
function $319e236875307eab$export$d10ae4f68404609a(assertiveness) {
  if ($319e236875307eab$var$liveAnnouncer) $319e236875307eab$var$liveAnnouncer.clear(assertiveness);
}
function $319e236875307eab$export$d8686216b8b81b2f() {
  if ($319e236875307eab$var$liveAnnouncer) {
    $319e236875307eab$var$liveAnnouncer.destroy();
    $319e236875307eab$var$liveAnnouncer = null;
  }
}
// LiveAnnouncer is implemented using vanilla DOM, not React. That's because as of React 18
// ReactDOM.render is deprecated, and the replacement, ReactDOM.createRoot is moved into a
// subpath import `react-dom/client`. That makes it hard for us to support multiple React versions.
// As a global API, we can't use portals without introducing a breaking API change. LiveAnnouncer
// is simple enough to implement without React, so that's what we do here.
// See this discussion for more details: https://github.com/reactwg/react-18/discussions/125#discussioncomment-2382638
var $319e236875307eab$var$LiveAnnouncer = /*#__PURE__*/function () {
  function $319e236875307eab$var$LiveAnnouncer() {
    _classCallCheck(this, $319e236875307eab$var$LiveAnnouncer);
    this.node = document.createElement("div");
    this.node.dataset.liveAnnouncer = "true";
    // copied from VisuallyHidden
    Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    });
    this.assertiveLog = this.createLog("assertive");
    this.node.appendChild(this.assertiveLog);
    this.politeLog = this.createLog("polite");
    this.node.appendChild(this.politeLog);
    document.body.prepend(this.node);
  }
  _createClass($319e236875307eab$var$LiveAnnouncer, [{
    key: "createLog",
    value: function createLog(ariaLive) {
      var node = document.createElement("div");
      node.setAttribute("role", "log");
      node.setAttribute("aria-live", ariaLive);
      node.setAttribute("aria-relevant", "additions");
      return node;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (!this.node) return;
      document.body.removeChild(this.node);
      this.node = null;
    }
  }, {
    key: "announce",
    value: function announce(message) {
      var assertiveness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "assertive";
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $319e236875307eab$var$LIVEREGION_TIMEOUT_DELAY;
      if (!this.node) return;
      var node = document.createElement("div");
      node.textContent = message;
      if (assertiveness === "assertive") this.assertiveLog.appendChild(node);else this.politeLog.appendChild(node);
      if (message !== "") setTimeout(function () {
        node.remove();
      }, timeout);
    }
  }, {
    key: "clear",
    value: function clear(assertiveness) {
      if (!this.node) return;
      if (!assertiveness || assertiveness === "assertive") this.assertiveLog.innerHTML = "";
      if (!assertiveness || assertiveness === "polite") this.politeLog.innerHTML = "";
    }
  }]);
  return $319e236875307eab$var$LiveAnnouncer;
}();
export { $319e236875307eab$export$a9b970dcc4ae71a9 as announce, $319e236875307eab$export$d10ae4f68404609a as clearAnnouncer, $319e236875307eab$export$d8686216b8b81b2f as destroyAnnouncer };